import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import MensajeWhatsappComponent from '../../Components/Admin/MensajeWhatsapp/MensajeWhatsapp';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';

export default function MensajeWhatsapp() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };
        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {usuarioLegued?.rol === 'admin' ? (
                                <MensajeWhatsappComponent />
                            ) : usuarioLegued?.rol === 'colaborador' ? (
                                <MensajeWhatsappComponent />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <MensajeWhatsappComponent />
                    )}
                </div>
            </section>
        </div>
    );
}
